import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DocumentSelector.css';

const DocumentSelector = () => {
  const navigate = useNavigate();

  const documentOptions = [
    {
      type: 'cv',
      title: 'CV / Resume',
      subtitle: 'Professional resume builder',
      description: 'Create professional CVs with experience descriptions and optimized formatting for your career goals.',
      icon: '📄'
    },
    {
      type: 'cover_letter',
      title: 'Cover Letter',
      subtitle: 'Personalized application letters',
      description: 'Generate compelling cover letters tailored to your target role and company.',
      icon: '✉️'
    },
    {
      type: 'personal_statement',
      title: 'Personal Statement',
      subtitle: 'University application essays',
      description: 'Build university application personal statements with structured guidance and feedback for improvement.',
      icon: '📝'
    }
  ];

  const handleDocumentSelect = (type) => {
    navigate(`/application-builder/form/${type}`);
  };

  return (
    <div className="document-selector">
      <div className="document-selector-container">
        <div className="document-selector-header">
          <h1>Application Builder</h1>
          <p>Choose a document type to get started</p>
        </div>

        <div className="document-selector-grid">
          {documentOptions.map((option, index) => (
            <button
              key={option.type}
              className="document-option"
              onClick={() => handleDocumentSelect(option.type)}
              aria-label={`Create ${option.title}`}
              tabIndex={0}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="document-option-icon">{option.icon}</div>
              <div className="document-option-title">{option.title}</div>
              <div className="document-option-subtitle">{option.subtitle}</div>
              <div className="document-option-description">{option.description}</div>
            </button>
          ))}
        </div>

        <div className="document-selector-footer">
          <p>All documents include real-time assistance and comprehensive editing tools</p>
        </div>
      </div>
    </div>
  );
};

export default DocumentSelector;



